import { invoke } from "@tauri-apps/api/core";

export type ScreenRecordingSettings = {
  directory: string;
  defaultDirectory: string;
};

export function getScreenRecordingSettings(): Promise<ScreenRecordingSettings> {
  return invoke("screen_recording_settings");
}

export function chooseScreenRecordingDirectory(): Promise<ScreenRecordingSettings | null> {
  return invoke("choose_screen_recording_directory");
}

export function resetScreenRecordingDirectory(): Promise<ScreenRecordingSettings> {
  return invoke("set_screen_recording_directory", { directory: null });
}
